import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import "./index.css";
import { AppShellSkeleton } from "./pages/app-shell/AppShellSkeleton";
import { detectAttribution } from "./services/attribution";
import { startCacheSync } from "./app/offlineCache";

// Before routing, which may drop the landing page's query string
detectAttribution();
startCacheSync(store);

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<AppShellSkeleton />}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>,
);
